<template>
  <el-dialog title="修改有效期" :visible.sync="modalShow">
    <el-form ref="form" :model="form" :rules="rules" size="small" label-width="100px">
      <el-form-item label="修改原因" prop="updateInvalidReason">
        <el-input v-model="form.updateInvalidReason" placeholder="修改原因" clearable />
      </el-form-item>
      <el-form-item label="结束日期" prop="expiryDate">
        <el-date-picker v-model="form.expiryDate" :value-format='"yyyy-MM-dd HH:mm:ss"' align="right" type="date" placeholder="选择日期" :picker-options="pickerOptions" />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="small" @click="modalShow = false">取消</el-button>
      <el-button type="primary" size="small" @click="submit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { userSkuupdate } from "@/api/product/classManage"
const rules = {
  updateInvalidReason: [
    { required: true, message: "请输入修改原因", trigger: "blur" },
  ],
  expiryDate: [
    { required: true, message: "请选择结束日期", trigger: "blur" },
  ]
}

export default {
  data () {
    return {
      modalShow: false,
      rules,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 86400000;
        },
        shortcuts: [{
          text: '今天',
          onClick (picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick (picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick (picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      form: {},
    }
  },
  methods: {
    init (item) {
      this.modalShow = true
      setTimeout(() => {
        this.$refs['form'].resetFields()
        this.form = Object.assign({}, item)
      }, 100);
    },
    async submit () {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return
        const params = {
          updateInvalidReason: this.form.updateInvalidReason,
          expiryDate: this.form.expiryDate,
          id: this.form.id
        }
        const res = await userSkuupdate(params)
        if (res.code !== 0) {
          this.$message.error(res.message)
          return
        }
        this.modalShow = false
        this.$message.success('操作成功！')
        this.$emit('update', true)
      })
    }
  }
}
</script>

<style>
</style>